import { TextField as MuiTextField } from '@mui/material';
import { forwardRef } from 'react';
import { IMaskInput } from 'react-imask';

const Mask = forwardRef((props, ref) => {
  const { onChange, ...passThroughProps } = props;

  return (
    <IMaskInput
      {...passThroughProps}
      definitions={{ '#': /[1-9]/ }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

export function TextField({
  mask,
  tabIndex,
  error,
  inputProps = {},
  InputProps = {},
  InputLabelProps = {},
  ...passThrough
}) {
  if (mask) Object.assign(InputProps, { inputComponent: Mask });
  Object.assign(InputLabelProps, { shrink: true });
  Object.assign(inputProps, { tabIndex, mask });

  return (
    <MuiTextField
      InputLabelProps={InputLabelProps}
      InputProps={InputProps}
      inputProps={inputProps}
      variant="outlined"
      error={Boolean(error)}
      helperText={error}
      {...passThrough}
    />
  );
}
